import { render } from "./InquiryDetail.m.backup.vue?vue&type=template&id=800b286c&scoped=true"
import script from "./InquiryDetail.m.backup.vue?vue&type=script&lang=js"
export * from "./InquiryDetail.m.backup.vue?vue&type=script&lang=js"

import "./InquiryDetail.m.backup.vue?vue&type=style&index=0&id=800b286c&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800b286c"]])

export default __exports__